module.exports = __webpack_public_path__ + "img/paraphraser.53ef823c.webp";